module.exports = __webpack_public_path__ + "img/Pauesg.0e1813db.jpg";